import React from "react";
import {
  TabbedForm,
  FormTab,
  EditController,
  // TitleForRecord,
  TextField,
  Toolbar,
  DeleteButton,
  useRecordContext,
  usePermissions
} from "react-admin";
import withStyles from '@mui/styles/withStyles';
import makeStyles from '@mui/styles/makeStyles';
import Card from "@mui/material/Card";
import editStyles from "./styles";
import { Feature }  from 'feature';
import PresentationDashboard from "dashboard/PresentationDashboard";
import { useClientContext } from 'contexts/client';

const useStyles = makeStyles({
  price: { color: "purple" },
});

const InfoBateField = (props) => {
  const classes = useStyles();
  return <TextField formClassName={classes.infobate_attr} {...props} />;
};
InfoBateField.defaultProps = {
  addLabel: true,
};

const RegionTitle = () => {
  const record = useRecordContext()
  return <span>{record ? `"${record.title}"` : ""}</span>;
};

const RegionToolbar = (props) => {
  const {  permissions  } = usePermissions()
  const { state: client } = useClientContext()
  const clientPrefix = client.client.resourcePrefix
  return (
    <Toolbar
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      {(permissions === "site_admin" ||
        permissions === `${clientPrefix}_admin`) && (
        <DeleteButton label="Delete" redirect="list" submitOnEnter={true} />
      )}
    </Toolbar>
  );
};

export default withStyles(editStyles)(({ classes, ...props }) => {
  React.useEffect(() => {}, []);
  const { state: client } = useClientContext()
  const clientPrefix = client.client.resourcePrefix
  const { permissions } = usePermissions()
  return (
    <EditController {...props} title={<RegionTitle />}>
      {(controllerProps) =>
        controllerProps.record ? (
          <div>
            <div>
              <div>
                <Card>
                  {/* <TitleForRecord
                    defaultTitle={
                      controllerProps.record
                        ? controllerProps.record.region_name + " Region"
                        : ""
                    }
                    record={controllerProps.record}
                  /> */}
                  <TabbedForm
                    {...controllerProps}
                    redirect={"edit"}
                    toolbar={<RegionToolbar permissions={permissions} />}
                  >
                    <FormTab label="Info">
                      <div style={{ display: "flex", width: "100%" }}>
                        <Feature name="dashboard">
                          <div style={{ flexGrow: 9 }}>
                          <PresentationDashboard
                            client={clientPrefix}
                            deploy_target="nacs_region"
                            filter_by={controllerProps.record.region_name}
                            filter_field={"nacs_region@eq"}
                          />
                        </div>
                        </Feature>
                        
                        <div style={{ flexShrink: 3, maxWidth: 240 }}></div>
                      </div>
                    </FormTab>
                  </TabbedForm>
                </Card>
              </div>
            </div>
          </div>
        ) : (
          ""
        )
      }
    </EditController>
  );
});
